if (document.body.classList.contains("home")) {
    let lastWindowWidth = window.innerWidth;

    const resize = () => {
        const scroll = document.querySelector(".mv__imgScroll");
        const svh = document.querySelector(".Svh");

        if (innerWidth > 1024) {
            scroll.style.top = "";
        } else {
            const nav = document.querySelector(".header__btns"),
                navInfo = nav.getBoundingClientRect();

            scroll.style.top = `${
                svh.getBoundingClientRect().height -
                (scroll.getBoundingClientRect().height +
                    navInfo.height +
                    (innerHeight - navInfo.bottom) * 2)
            }px`;
        }
    };

    resize();
    window.addEventListener("resize", () => {
        setTimeout(() => {
            const currentWindowWidth = window.innerWidth;
            if (currentWindowWidth !== lastWindowWidth) {
                resize();
                lastWindowWidth = currentWindowWidth;
            }
        }, 200);
    });
}
